import { useEffect, useState } from "react"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import API_BASE_URL from "../../../../Constants";

export default function EmployeeLog() {

    const [employeeList, setEmployeeList] = useState([]);
    const [selectedEmployeeLog, setSelectedEmployeeLog] = useState([]);
    const [unfilteredLog, setUnfilteredLog] = useState([]);
    const [isActive, setIsActive] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    useEffect(() => {

        // Initial Fetch of all employees in users table
        const fetchEmployees = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/admin/users`, {
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setEmployeeList(data.sort((a, b) => a.firstName.localeCompare(b.firstName)));
            }
            catch (error) {
                console.error('Fetch error: ', error);
            }
        };
        fetchEmployees();
    }, []);


    useEffect(() => {
        filterDate();
    }, [startDate, endDate, unfilteredLog]);


    const filterDate = () => {
        if (startDate !== "" && endDate !== "") {
            if (endDate >= startDate) { }
            setSelectedEmployeeLog(unfilteredLog.filter((log) => new Date(log.date) >= new Date(startDate) && new Date(log.date) <= new Date(endDate)));
        }
        else {

            setSelectedEmployeeLog(unfilteredLog);
        }
    };

    const handleStartDate = (target) => {
        if (target !== "") {
            setStartDate(new Date(target))
        }
        else {
            setStartDate("");
        }
    }

    const handleEndDate = (target) => {
        if (target !== "") {
            setEndDate(new Date(target))
        }
        else {
            setEndDate("");
        }
    }

    // Fetch employee log based on employee id
    const fetchEmployeeLog = async (employeeId) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/callcenter/log/${employeeId}`, {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            data.sort((a, b) => new Date(a.date) - new Date(b.date));

            //If employeeId is 0, recieved an empty employee log and should not be shown. Save selected log data to copy
            data.employeeId !== 0 ? setSelectedEmployeeLog(data) : setSelectedEmployeeLog([]);
            data.employeeId !== 0 ? setUnfilteredLog(data) : setUnfilteredLog([]);
        }
        catch (error) {
            console.error('Fetch error: ', error);
        }
    };


    //Keeping button in focus unless another personnel button is clicked
    const activeEmployee = (target) => {
        if (isActive) {
            isActive.classList.remove('bg-blue-500', 'text-white');
        }
        target.classList.add('bg-blue-500', 'text-white');
        setIsActive(target);

    };


    //Export to .xlsx file and download functionality
    const exportData = (data, filename) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
    }


    return (
        <div className="mx-auto h-screen w-full flex">
            <div className="h-auto px-1 py-2 w-[300px] min-w-[250px] resize-x bg-white rounded-lg shadow-lg border-2 mt-11 border-gray-200">
                <div className=" items-center bg-white shadow-lg overflow-hidden border-2 mt-1 border-gray-200">
                    <h1 className="px-4 bg-gray-200 w-full text-center font-semibold text-gray-600">All Personnel</h1>
                </div>

                <div className="w-full h-screen text-center bg-white shadow-lg overflow-auto border-2 mt-2 border-gray-200">
                    {employeeList.map((log) => (
                        <button key={log.id} className="pointer-events-auto focus:bg-blue-500 focus:text-white border-2 px-2 py-1 mt-2 w-11/12 overflow-hidden font-semibold rounded-md focus:outline-none focus:ring-blue-400" onClick={(e) => { fetchEmployeeLog(log.id); activeEmployee(e.target) }}>{log.firstName} {log.lastName}</button>
                    ))}
                </div>
            </div>

            <div className="w-full mt-10">
                <table>
                    <tbody className="bg-gray-200">

                        <tr>
                            <td className="text-right px-4 py-4 font-semibold text-gray-600 w-1/4">Date From:</td>
                            <td className="text-left px-4 py-4 font-semibold text-gray-600 ">
                                <input type="date" name="dateStart" className="border-2 border-gray-700 border-opacity-40 h-10 rounded-md focus:outline-none" onChange={(e) => { handleStartDate(e.target.value); filterDate() }} />
                            </td>
                            <td className="text-right px-4 py-4 font-semibold text-gray-600 w-1/4">Date To:</td>
                            <td className="text-left px-4 py-4 font-semibold text-gray-600 ">
                                <input type="date" name="dateStart" className="border-2 border-gray-700 border-opacity-40 h-10 rounded-md focus:outline-none" onChange={(e) => { handleEndDate(e.target.value); filterDate() }} />
                            </td>
                            <td className="px-4 py-4 font-semibold text-gray-600 w-full" colSpan={2}>
                                <button className="w-1/4 py-2 mx-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400" onClick={() => exportData(selectedEmployeeLog, 'EmployeeLogs.xlsx')}>Export Excel</button>
                            </td>
                        </tr>
                        <tr className="text-right px-4 py-4 font-semibold text-gray-600">
                            {isActive === null ? "" : <td className="text-right px-4 py-4 font-semibold text-gray-600 w-1/4">Now Viewing:</td>}
                            {isActive === null ? "" : <td className="text-left px-4 py-4 font-semibold text-gray-600" >{isActive.textContent}</td>}
                            {isActive === null ? "" : <td className="text-right px-4 py-4 font-semibold text-gray-600 w-1/4 " >Total hours in time period:</td>}
                            {isActive === null ? "" : <td className="text-left px-4 py-4 font-semibold text-gray-600">{selectedEmployeeLog.reduce((total, curr) => total + curr.hours, 0).toFixed(2)}</td>}
                            {isActive === null ? "" : <td className="text-right px-4 py-4 font-semibold text-gray-600 w-1/4 " >Total overtime in time period:</td>}
                            {isActive === null ? "" : <td className="text-left px-4 py-4 font-semibold text-gray-600" >{selectedEmployeeLog.reduce((total, curr) => total + curr.overtime, 0).toFixed(2)}</td>}
                        </tr>
                    </tbody>
                </table>
                <table className="w-full bg-white shadow-lg overflow-hidden border-2 mt-1 border-gray-200">
                    <thead className="bg-gray-200 w-full">
                        <tr >
                            <th className="px-4 py-2 font-semibold text-gray-600">Date</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Location</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Dispatch Type</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Time In</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Time Out</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Hours</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Overtime</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">#Dvcs</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Device(s)</th>
                            <th className="px-4 py-2 font-semibold text-gray-600">Dispatch #</th>
                        </tr>
                    </thead>

                    <tbody className="text-gray-700">
                        {selectedEmployeeLog.map((log) => (
                            <tr key={log.id} className="border-t">
                                <td className="px-4 py-2 text-center">{log.date}</td>
                                <td className="px-4 py-2 text-center">{log.location}</td>
                                <td className="px-4 py-2 text-center">{log.dispatchType}</td>
                                <td className="px-4 py-2 text-center">{log.timeIn.slice(11, 19).replace('T', ' ')}</td>
                                <td className="px-4 py-2 text-center">{log.timeOut.slice(11, 19).replace('T', ' ')}</td>
                                <td className="px-4 py-2 text-center">{log.hours.toFixed(2)}</td>
                                <td className="px-4 py-2 text-center">{log.overtime.toFixed(2)}</td>
                                <td className="px-4 py-2 text-center">{log.dvcs}</td>
                                <td className="px-4 py-2 text-center">{log.device}</td>
                                <td className="px-4 py-2 text-center">{log.dispatchNumber}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}



